import React from 'react';
import styled from 'styled-components';

const StyledImg = styled.img`
  border-radius: 10px;
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 140px;
    height: 140px;
    margin-left: -20px;
  }
`;

export default function ImgFit({ src, ...props }) {
  return <StyledImg src={src} {...props} />;
}
